import { render, staticRenderFns } from "./LoadingSkeleton.vue?vue&type=template&id=8bed41de&scoped=true"
import script from "./LoadingSkeleton.vue?vue&type=script&lang=js"
export * from "./LoadingSkeleton.vue?vue&type=script&lang=js"
import style0 from "./LoadingSkeleton.vue?vue&type=style&index=0&id=8bed41de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bed41de",
  null
  
)

export default component.exports